/* ============================================================
   Snuzone Facets v3.0.0 – "Sheet Kompakt" (24.10.2026)
   ------------------------------------------------------------
   Zuständig für:
   - Bottom-Sheet (Mobile) mit Gesten-Layer: Spring-Animation,
     1:1-Ziehen am Griff/Kopf, Velocity-Übergabe, Rubber-Band,
     unterbrechbar. Keine CSS-Transition auf dem Sheet.
   - Dropdown-Panels (Desktop)
   - AJAX-Filterung über die Section Rendering API:
     fetch(url + &sections=mainId,filterId) → beide Sections
     werden geswappt, danach pushState.
   - State-Restore nach jedem Swap (Sheet offen, Akkordeons,
     Panel, Scrollposition, Marken-Suche, „Alle Marken“), da das
     Filter-Markup serverseitig komplett neu gerendert wird.
   - Marken-Suche und „Alle Marken“ rein clientseitig (kein Fetch).

   Alle Events laufen delegiert über document und überleben
   dadurch jeden DOM-Swap. Das Script wird nie erneut ausgeführt.

   Changelog
   v3.0.0 - Gesten-Layer für das Sheet (DS 3.5 „Interaktion & Gesten“):
            Spring d=1.0/r=0.35s beim Öffnen, d=0.85/r=0.30s nach Wisch
            mit Schwung; Schließen entscheidet die Richtung der
            Geschwindigkeit; Rubber-Band nach oben; Multi-Touch-Schutz;
            Reduced Motion = Opacity-Crossfade.
          - DOM-Swap wird zurückgestellt, solange ein Finger am Sheet
            ist (sonst verliert der Pointer sein Capture-Ziel).
          - Scrollposition des Sheets wird beim Swap gesichert, nicht
            beim Absenden (langsame Verbindungen).
          - Sticky-Fixed-Modus: Dirty-Flag statt Layout-Read in jedem
            Frame (Scroll/Resize setzen das Flag, rAF liest einmal).
          - Marken-Suche (Mobile + Desktop) und Limit-Aufklapp,
            Zustand überlebt Swaps.
          - Preis: Enter/Change wie bisher.
   v2.5   Letzter Stand vor dem DS-3.5-Pass.
   ============================================================ */

(function () {
  'use strict';

  if (window.__snzFacetsInit) return;
  window.__snzFacetsInit = true;

  var doc = document;
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Helpers ---------- */

  function qs(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function now() { return (window.performance && performance.now) ? performance.now() : Date.now(); }

  function getSectionIds() {
    var main = qs('#CollectionAjaxResult');
    var filt = qs('[data-snz-filter-section]');
    return {
      main: main ? main.getAttribute('data-section-id') : null,
      filter: filt ? filt.getAttribute('data-section-id') : null
    };
  }

  /* ---------- UI-State (überlebt Swaps) ---------- */

  var ui = {
    sheetOpen: false,
    sheetScroll: 0,
    accStates: null,     // { param_name: true/false } – null = Server-Defaults
    openPanel: null,     // Desktop-Panel-Key
    lastTrigger: null,
    brandQuery: { m: '', d: '' },
    brandAll: false,     // „Alle Marken“ aufgeklappt (Mobile)
    brandFocus: null     // 'm' | 'd' – Suchfeld hatte Fokus beim Swap
  };

  function captureUiState() {
    var sheet = qs('[data-snz-sheet]');
    var body = qs('[data-snz-sheet-body]');
    ui.sheetOpen = !!(sheet && sheet.classList.contains('on'));
    ui.sheetScroll = body ? body.scrollTop : 0;

    var states = {};
    qsa('[data-snz-acc]').forEach(function (acc) {
      states[acc.getAttribute('data-snz-acc')] = acc.classList.contains('open');
    });
    ui.accStates = states;

    var openPanel = qs('.snz-fd__panel:not([hidden])');
    ui.openPanel = openPanel ? openPanel.getAttribute('data-snz-dd-panel') : null;

    ui.brandFocus = null;
    qsa('[data-snz-brand-search]').forEach(function (inp) {
      var scope = brandScopeOf(inp);
      ui.brandQuery[scope] = inp.value;
      if (doc.activeElement === inp) ui.brandFocus = scope;
    });
  }

  function restoreUiState() {
    if (ui.accStates) {
      qsa('[data-snz-acc]').forEach(function (acc) {
        var key = acc.getAttribute('data-snz-acc');
        if (key in ui.accStates) {
          acc.classList.toggle('open', ui.accStates[key]);
          var head = qs('[data-snz-acc-head]', acc);
          if (head) head.setAttribute('aria-expanded', ui.accStates[key] ? 'true' : 'false');
        }
      });
    }

    if (ui.sheetOpen) {
      Sheet.restoreOpen();
      var body = qs('[data-snz-sheet-body]');
      if (body) body.scrollTop = ui.sheetScroll;
    }

    if (ui.openPanel) {
      var panel = qs('.snz-fd__panel[data-snz-dd-panel="' + ui.openPanel + '"]');
      var trigger = qs('.snz-fd__t[data-snz-dd="' + ui.openPanel + '"]');
      if (panel) panel.hidden = false;
      if (trigger) {
        trigger.classList.add('open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    }

    // Marken: Aufklapp-Zustand und Suche wiederherstellen
    if (ui.brandAll) revealAllBrands();
    qsa('[data-snz-brand-search]').forEach(function (inp) {
      var scope = brandScopeOf(inp);
      var q = ui.brandQuery[scope] || '';
      if (q) { inp.value = q; applyBrandSearch(inp); }
      if (ui.brandFocus === scope) {
        try { inp.focus({ preventScroll: true }); inp.setSelectionRange(inp.value.length, inp.value.length); } catch (e) { /* noop */ }
      }
    });
  }

  /* ---------- Marken-Suche + Limit (clientseitig) ---------- */

  function brandScopeOf(inputOrList) {
    var wrap = inputOrList.closest('.snz-acc__bd, .snz-fd__panel-in');
    var list = wrap ? qs('[data-snz-brand-list]', wrap) : null;
    return list ? (list.getAttribute('data-snz-brand-scope') || 'm') : 'm';
  }

  function brandListFor(input) {
    var wrap = input.closest('.snz-acc__bd, .snz-fd__panel-in');
    return wrap ? qs('[data-snz-brand-list]', wrap) : null;
  }

  function revealAllBrands() {
    qsa('[data-snz-brand-list] [data-snz-extra]').forEach(function (chip) {
      chip.hidden = false;
      chip.removeAttribute('data-snz-extra');
    });
    qsa('[data-snz-brand-more]').forEach(function (btn) { btn.hidden = true; });
  }

  function applyBrandSearch(input) {
    var list = brandListFor(input);
    if (!list) return;
    var wrap = input.closest('.snz-acc__bd, .snz-fd__panel-in');
    var none = wrap ? qs('[data-snz-brand-none]', wrap) : null;
    var more = wrap ? qs('[data-snz-brand-more]', wrap) : null;
    var q = (input.value || '').trim().toLowerCase();
    var hits = 0;
    qsa('.snz-vchip', list).forEach(function (chip) {
      var label = chip.getAttribute('data-snz-label') || chip.textContent.toLowerCase();
      var isExtra = chip.hasAttribute('data-snz-extra');
      var match = q === '' ? true : label.indexOf(q) > -1;
      // Bei aktiver Suche gilt das Limit nicht; ohne Suche greift es wieder
      chip.hidden = q === '' ? isExtra : !match;
      if (match && q !== '') hits++;
      if (q === '' && !isExtra) hits++;
    });
    if (none) none.hidden = !(q !== '' && hits === 0);
    if (more) more.hidden = q !== '' || ui.brandAll;
  }

  /* ---------- Spring (DS 3.5: Default d=1 r=.35s; nach Wisch d=.85 r=.3s) ---------- */

  function spring(from, to, v0, damping, response, onUpdate, onDone) {
    var k = Math.pow(2 * Math.PI / response, 2);
    var c = 2 * damping * Math.sqrt(k);
    var x = from, v = v0, last = now(), raf;
    function step(t) {
      var dt = Math.min(0.032, (t - last) / 1000);
      last = t;
      var a = -k * (x - to) - c * v;
      v += a * dt;
      x += v * dt;
      if (Math.abs(x - to) < 0.3 && Math.abs(v) < 20) {
        onUpdate(to);
        if (onDone) onDone();
        return;
      }
      onUpdate(x);
      raf = window.requestAnimationFrame(step);
    }
    raf = window.requestAnimationFrame(step);
    return function cancel() {
      window.cancelAnimationFrame(raf);
      return { x: x, v: v };
    };
  }

  function rubber(offset, dim, c) {
    c = c || 0.55;
    return (offset * dim * c) / (dim + c * Math.abs(offset));
  }

  /* ---------- Sheet-Controller (Gesten-Layer) ----------
     Das Sheet-Element wird bei jedem Swap ersetzt; der Controller
     hält deshalb keinen Knoten, sondern nur Zustand (offen, y, H)
     und fragt das aktuelle Element bei jedem Schritt frisch ab. */

  var Sheet = (function () {
    var open = false;      // logisch offen (auch während Schließ-Animation bis finish)
    var y = 0;             // aktueller translateY in px (0 = offen)
    var H = 0;             // Sheet-Höhe
    var cancel = null;     // laufende Spring abbrechen → {x, v}
    var drag = null;       // laufender Pointer-Drag
    var closing = false;

    function el() { return qs('[data-snz-sheet]'); }
    function ov() { return qs('[data-snz-overlay]'); }

    function setY(val) {
      y = val;
      var s = el(), o = ov();
      if (s) s.style.transform = 'translate3d(0,' + val + 'px,0)';
      if (o && H) o.style.opacity = String(Math.max(0, Math.min(1, 1 - val / H)));
    }

    function stop() {
      if (cancel) { var st = cancel(); cancel = null; return st; }
      return { x: y, v: 0 };
    }

    function measure() {
      var s = el();
      H = s ? s.offsetHeight : 0;
      if (!H) H = Math.round(window.innerHeight * 0.88);
    }

    function lock(on) {
      doc.documentElement.classList.toggle('snz-lock', on);
    }

    function prepareOpenDom() {
      var s = el(), o = ov();
      if (!s || !o) return false;
      o.hidden = false;
      o.classList.add('on');
      s.classList.add('on', 'snz-moving');
      lock(true);
      return true;
    }

    function finishClose() {
      var s = el(), o = ov();
      closing = false;
      open = false;
      if (s) {
        s.classList.remove('on', 'snz-moving');
        s.style.transform = 'translate3d(0,103%,0)';
        s.style.opacity = '';
        s.style.transition = '';
      }
      if (o) {
        o.classList.remove('on');
        o.style.opacity = '0';
        o.style.transition = '';
        o.hidden = true;
      }
      lock(false);
      if (ui.lastTrigger && doc.contains(ui.lastTrigger)) {
        ui.lastTrigger.focus({ preventScroll: true });
      }
      ui.lastTrigger = null;
      ui.sheetOpen = false;
    }

    function show(trigger) {
      ui.lastTrigger = trigger || null;
      var wasOpen = open;
      var st = stop();
      if (!prepareOpenDom()) return;
      measure();
      open = true;
      closing = false;
      ui.sheetOpen = true;
      var s = el();

      if (reducedMotion) {
        setY(0);
        s.style.transition = 'opacity 200ms';
        s.style.opacity = '0';
        var o = ov();
        if (o) { o.style.transition = 'opacity 200ms'; o.style.opacity = '0'; }
        window.requestAnimationFrame(function () {
          s.style.opacity = '1';
          if (o) o.style.opacity = '1';
          window.setTimeout(function () { s.classList.remove('snz-moving'); s.focus({ preventScroll: true }); }, 220);
        });
        return;
      }

      // Start immer vom aktuellen Bildschirmwert (Unterbrechbarkeit), nie vom Zielwert
      var start = wasOpen ? st.x : H;
      setY(start);
      cancel = spring(start, 0, wasOpen ? st.v : 0, 1, 0.35, setY, function () {
        cancel = null;
        var sh = el();
        if (sh) { sh.classList.remove('snz-moving'); sh.focus({ preventScroll: true }); }
      });
    }

    function hide(v0, damping) {
      if (!open) return;
      var s = el(), o = ov();
      if (!s) { finishClose(); return; }
      closing = true;
      s.classList.add('snz-moving');

      if (reducedMotion) {
        s.style.transition = 'opacity 200ms';
        s.style.opacity = '0';
        if (o) { o.style.transition = 'opacity 200ms'; o.style.opacity = '0'; }
        window.setTimeout(finishClose, 200);
        return;
      }

      var st = stop();
      // Exit eine Stufe schneller als Enter (r=.30 statt .35)
      cancel = spring(st.x, H + 8, v0 || 0, damping || 1, 0.3, setY, function () {
        cancel = null;
        finishClose();
      });
    }

    /* Nach einem DOM-Swap: neues Sheet-Element in den aktuellen Zustand setzen, ohne Animation */
    function restoreOpen() {
      if (!open) return;
      var s = el(), o = ov();
      if (!s || !o) return;
      o.hidden = false;
      o.classList.add('on');
      s.classList.add('on');
      lock(true);
      measure();
      if (cancel) s.classList.add('snz-moving');
      setY(y);
      if (reducedMotion) { s.style.opacity = '1'; o.style.opacity = '1'; }
    }

    /* ---- Ziehen am Griff/Kopf: 1:1, Greifpunkt bleibt, Rubber-Band nach oben ---- */

    function onDown(e) {
      var g = e.target.closest('[data-snz-grab]');
      if (!g || !open || drag || reducedMotion) return;
      if (e.target.closest('button, a, input')) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      try { g.setPointerCapture(e.pointerId); } catch (err) { /* noop */ }
      var st = stop();
      var s = el();
      if (s) s.classList.add('snz-moving');
      drag = { id: e.pointerId, target: g, y0: e.clientY, base: st.x, samples: [[now(), st.x]] };
      e.preventDefault();
    }

    function onMove(e) {
      if (!drag || e.pointerId !== drag.id) return; // Multi-Touch-Schutz: nur der erste Zeiger
      var dy = e.clientY - drag.y0 + drag.base;
      var ny = dy >= 0 ? dy : rubber(dy, H, 0.55);
      setY(ny);
      drag.samples.push([now(), ny]);
      if (drag.samples.length > 6) drag.samples.shift();
    }

    function onUp(e) {
      if (!drag || e.pointerId !== drag.id) return;
      var s = drag.samples, v = 0;
      if (s.length > 1) {
        var a = s[0], b = s[s.length - 1];
        var dt = (b[0] - a[0]) / 1000;
        if (dt > 0) v = (b[1] - a[1]) / dt;
      }
      drag = null;
      // Projektion ~100ms voraus; Richtung der Geschwindigkeit entscheidet
      var projected = y + v * 0.1;
      if (v > 500 || (projected > H * 0.45 && v > -200)) {
        hide(v, 0.85);
      } else {
        cancel = spring(y, 0, v, Math.abs(v) > 300 ? 0.85 : 1, 0.3, setY, function () {
          cancel = null;
          var sh = el();
          if (sh) sh.classList.remove('snz-moving');
        });
      }
      flushPendingSwap();
    }

    doc.addEventListener('pointerdown', onDown, { passive: false });
    doc.addEventListener('pointermove', onMove, { passive: true });
    doc.addEventListener('pointerup', onUp, { passive: true });
    doc.addEventListener('pointercancel', onUp, { passive: true });

    return {
      show: show,
      hide: function () { hide(0, 1); },
      restoreOpen: restoreOpen,
      isOpen: function () { return open; },
      isDragging: function () { return !!drag; }
    };
  })();

  /* ---------- Desktop-Panels ---------- */

  function closeAllPanels() {
    qsa('.snz-fd__panel').forEach(function (p) { p.hidden = true; });
    qsa('.snz-fd__t').forEach(function (t) {
      t.classList.remove('open');
      t.setAttribute('aria-expanded', 'false');
    });
    ui.openPanel = null;
  }

  function togglePanel(trigger) {
    var key = trigger.getAttribute('data-snz-dd');
    var panel = qs('.snz-fd__panel[data-snz-dd-panel="' + key + '"]');
    if (!panel) return;
    var wasOpen = !panel.hidden;
    closeAllPanels();
    if (!wasOpen) {
      panel.hidden = false;
      trigger.classList.add('open');
      trigger.setAttribute('aria-expanded', 'true');
      ui.openPanel = key;
    }
  }

  /* ---------- AJAX: Section-API mit Dokument-Fallback ---------- */

  var currentFetch = null;
  var pendingSwap = null; // Antwort, die während eines Drags eintraf

  function swapSection(id, html) {
    if (!html) {
      console.warn('[snz-facets] Keine Section-HTML für:', id);
      return false;
    }
    var wrapper = doc.getElementById('shopify-section-' + id);
    if (!wrapper) {
      console.warn('[snz-facets] Wrapper fehlt im DOM: #shopify-section-' + id);
      return false;
    }
    var tmp = doc.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.firstElementChild;
    wrapper.innerHTML = fresh ? fresh.innerHTML : html;
    return true;
  }

  function fetchViaSectionsApi(target, ids) {
    var u = new URL(target.toString());
    u.searchParams.set('sections', ids.main + ',' + ids.filter);
    return window.fetch(u.toString(), { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (json) {
        if (!json[ids.main] && !json[ids.filter]) {
          console.warn('[snz-facets] Sections-Antwort ohne passende Keys. Erwartet:', ids.main, '+', ids.filter, '| erhalten:', Object.keys(json));
          throw new Error('Antwort enthält keine der angefragten Sections');
        }
        return { main: json[ids.main] || null, filter: json[ids.filter] || null, via: 'sections-api' };
      });
  }

  function fetchViaDocument(target, ids) {
    return window.fetch(target.toString(), { headers: { Accept: 'text/html' } })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var m = parsed.getElementById('shopify-section-' + ids.main);
        var f = parsed.getElementById('shopify-section-' + ids.filter);
        if (!m && !f) throw new Error('Sections im Dokument nicht gefunden');
        return { main: m ? m.outerHTML : null, filter: f ? f.outerHTML : null, via: 'document' };
      });
  }

  /* ---------- Reinit nach Grid-Swap (unverändert seit v2.5) ---------- */

  var reinitLogged = false;

  function remountPicoapp() {
    var candidates = [window.app, window.App, window.__app, window.theme && window.theme.app];
    for (var i = 0; i < candidates.length; i++) {
      var c = candidates[i];
      if (c && typeof c.mount === 'function') {
        try { c.mount(); return true; }
        catch (err) { console.warn('[snz-facets] picoapp mount() fehlgeschlagen:', err); return false; }
      }
    }
    return false;
  }

  var atcProxy = null;

  function ensureAtcProxy() {
    if (atcProxy && doc.contains(atcProxy)) return atcProxy;
    var btn = qs('#CollectionAjaxResult [data-mobile-add-to-cart]');
    if (!btn || !btn.parentNode) return null;
    btn.parentNode.removeChild(btn);
    btn.setAttribute('data-snz-atc-proxy', '');
    btn.setAttribute('aria-hidden', 'true');
    btn.style.display = 'none';
    doc.body.appendChild(btn);
    atcProxy = btn;
    return atcProxy;
  }

  function tagUnboundAtc() {
    qsa('#CollectionAjaxResult [data-mobile-add-to-cart]').forEach(function (b) {
      b.setAttribute('data-snz-unbound', '');
    });
  }

  function openMobileAtc(handle) {
    var proxy = ensureAtcProxy();
    if (proxy) {
      var orig = proxy.getAttribute('data-handle');
      proxy.setAttribute('data-handle', handle);
      window.__snzQuickShopClick = true;
      try {
        proxy.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      } finally {
        proxy.setAttribute('data-handle', orig || '');
        window.setTimeout(function () { window.__snzQuickShopClick = false; }, 0);
      }
      return;
    }
    console.warn('[snz-facets] Kein ATC-Proxy verfügbar – Fallback-Modal');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.fetch(root + 'products/' + encodeURIComponent(handle) + '?view=ajax-product')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var modal = qs('.ModalForm');
        if (!modal) return;
        modal.innerHTML = html;
        modal.classList.add('active');
      })
      .catch(function (err) { console.warn('[snz-facets] Fallback-Modal fehlgeschlagen:', err); });
  }

  function reinitThemeGrid() {
    var picoappMounted = remountPicoapp();
    try {
      if (window.theme && typeof window.theme.reinitProductGridItem === 'function') window.theme.reinitProductGridItem();
    } catch (err) { console.warn('[snz-facets] Theme-Reinit fehlgeschlagen:', err); }
    try {
      if (window._swat && typeof window._swat.initializeActionButtons === 'function') window._swat.initializeActionButtons('#CollectionAjaxResult');
    } catch (err) { console.warn('[snz-facets] Swym-Reinit fehlgeschlagen:', err); }
    if (!reinitLogged) {
      reinitLogged = true;
      console.info('[snz-facets] Reinit-Wege:', {
        picoappMount: picoappMounted,
        reinitProductGridItem: !!(window.theme && typeof window.theme.reinitProductGridItem === 'function'),
        swym: !!(window._swat && typeof window._swat.initializeActionButtons === 'function')
      });
    }
  }

  /* ---------- Swap anwenden (ggf. aufgeschoben, solange ein Drag läuft) ---------- */

  function applySwap(result, ids, target, opts) {
    // Zustand JETZT sichern (nicht beim Absenden): bei langsamer Verbindung hat
    // der Nutzer inzwischen gescrollt, gesucht oder Akkordeons umgeschaltet.
    captureUiState();
    ensureAtcProxy();

    var preservedDesc = qs('#collection-description');
    if (preservedDesc && preservedDesc.parentNode) preservedDesc.parentNode.removeChild(preservedDesc);

    var okMain = swapSection(ids.main, result.main);
    var okFilter = swapSection(ids.filter, result.filter);
    if (!okMain && !okFilter) throw new Error('Swap fehlgeschlagen (' + result.via + ')');

    if (preservedDesc) {
      var freshDesc = qs('#collection-description');
      if (freshDesc && freshDesc.parentNode) freshDesc.parentNode.replaceChild(preservedDesc, freshDesc);
    }
    if (!opts.skipHistory) {
      window.history.pushState({ snzFacets: true }, '', target.pathname + target.search);
    }
    restoreUiState();
    markStickyDirty();
    tagUnboundAtc();
    reinitThemeGrid();
    doc.dispatchEvent(new CustomEvent('snz:facets:updated'));
  }

  function flushPendingSwap() {
    if (!pendingSwap || Sheet.isDragging()) return;
    var p = pendingSwap;
    pendingSwap = null;
    try {
      applySwap(p.result, p.ids, p.target, p.opts);
    } catch (err) {
      console.warn('[snz-facets] Aufgeschobener Swap fehlgeschlagen, Vollnavigation:', err);
      window.location.href = p.target.toString();
      return;
    }
    if (currentFetch === p.token) doc.documentElement.classList.remove('snz-facets-loading');
  }

  function navigate(url, opts) {
    opts = opts || {};
    var ids = getSectionIds();

    if (!ids.main || !ids.filter || !window.fetch || !window.URL || !window.DOMParser) {
      console.warn('[snz-facets] Vollnavigation – main:', ids.main, '| filter:', ids.filter);
      window.location.href = url;
      return;
    }

    var target;
    try { target = new URL(url, window.location.origin); }
    catch (e) { window.location.href = url; return; }

    doc.documentElement.classList.add('snz-facets-loading');
    var token = {};
    currentFetch = token;
    pendingSwap = null; // ältere, aufgeschobene Antwort ist jetzt veraltet
    var t0 = now();

    fetchViaSectionsApi(target, ids)
      .catch(function (err) {
        console.warn('[snz-facets] Section-API fehlgeschlagen (' + err.message + '), Dokument-Fallback …');
        return fetchViaDocument(target, ids);
      })
      .then(function (result) {
        if (currentFetch !== token) return; // veraltete Antwort verwerfen
        console.info('[snz-facets] Gefiltert via ' + result.via + ' in ' + Math.round(now() - t0) + 'ms');
        if (Sheet.isDragging()) {
          pendingSwap = { result: result, ids: ids, target: target, opts: opts, token: token };
          return; // Loading-Klasse bleibt bis zum Flush
        }
        applySwap(result, ids, target, opts);
      })
      .catch(function (err) {
        console.warn('[snz-facets] AJAX endgültig fehlgeschlagen, Vollnavigation:', err);
        window.location.href = url;
      })
      .then(function () {
        if (currentFetch === token && !pendingSwap) {
          doc.documentElement.classList.remove('snz-facets-loading');
        }
      });
  }

  /* ---------- Param-Navigation (optimistisch) ---------- */

  function removeParamValue(params, key, value) {
    var kept = [];
    params.getAll(key).forEach(function (v) { if (v !== value) kept.push(v); });
    params.delete(key);
    kept.forEach(function (v) { params.append(key, v); });
  }

  function optimisticToggle(el) {
    if (el.classList.contains('snz-achip')) {
      el.style.opacity = '0.4';
      el.style.pointerEvents = 'none';
      return;
    }
    if (el.hasAttribute('data-snz-sort')) {
      var group = el.parentElement;
      if (group) {
        qsa('.snz-rrow', group).forEach(function (r) { r.classList.remove('sel'); r.setAttribute('aria-checked', 'false'); });
      }
      el.classList.add('sel');
      el.setAttribute('aria-checked', 'true');
      return;
    }
    var on = el.classList.toggle('sel');
    if (on) el.setAttribute('aria-current', 'true'); else el.removeAttribute('aria-current');
  }

  function applyParamNavigation(el) {
    var param = el.getAttribute('data-snz-param');
    var value = el.getAttribute('data-snz-value');
    var params = new URLSearchParams(window.location.search);

    if (param === 'sort_by') {
      params.set('sort_by', value);
    } else if (el.hasAttribute('data-snz-active')) {
      removeParamValue(params, param, value);
      el.removeAttribute('data-snz-active');
    } else {
      params.append(param, value);
      el.setAttribute('data-snz-active', '');
    }

    optimisticToggle(el);

    var query = params.toString();
    var newUrl = window.location.pathname + (query ? '?' + query : '');
    window.history.pushState({ snzFacets: true }, '', newUrl);
    navigate(newUrl, { skipHistory: true });
  }

  /* ---------- Preis ---------- */

  function normalizePrice(value) {
    var v = String(value || '').replace(',', '.').replace(/[^\d.]/g, '');
    if (v === '' || isNaN(parseFloat(v))) return null;
    return parseFloat(v);
  }

  function applyPrice(wrap) {
    var gteInput = qs('[data-snz-price="gte"]', wrap);
    var lteInput = qs('[data-snz-price="lte"]', wrap);
    var gte = normalizePrice(gteInput && gteInput.value);
    var lte = normalizePrice(lteInput && lteInput.value);

    var params = new URLSearchParams(window.location.search);
    if (gte !== null) params.set('filter.v.price.gte', gte); else params.delete('filter.v.price.gte');
    if (lte !== null) params.set('filter.v.price.lte', lte); else params.delete('filter.v.price.lte');

    var query = params.toString();
    var newUrl = window.location.pathname + (query ? '?' + query : '');
    window.history.pushState({ snzFacets: true }, '', newUrl);
    navigate(newUrl, { skipHistory: true });
  }

  /* ---------- Sticky via Fixed-Modus (Dirty-Flag) ----------
     position:sticky bricht in dieser Template-Struktur, daher Fixed-Modus
     mit Platzhalter. Neu in v3.0: Layout wird nur gelesen, wenn Scroll,
     Resize oder ein Swap das Flag gesetzt haben – kein getBoundingClientRect
     in jedem Frame mehr. Scroll wird in der Capture-Phase abgehört, damit
     auch innere Scroll-Container (Theme) zählen. */

  var mqDesktop = window.matchMedia ? window.matchMedia('(min-width: 750px)') : null;
  var fixedPlaceholder = null;
  var isFixed = false;
  var pinnedLogged = false;
  var stickyDirty = true;
  var stickyRaf = null;

  var HEADER_CANDIDATES = ['header.site-header', '.site-header__wrapper', '#HeaderWrapper', '#shopify-section-header'];

  function getHeaderBottom(root) {
    var isDesktop = mqDesktop ? mqDesktop.matches : true;
    var manual = parseInt(root.getAttribute(isDesktop ? 'data-snz-offset-d' : 'data-snz-offset-m'), 10) || 0;
    if (manual) return manual;
    var best = 0, bestSel = null;
    for (var i = 0; i < HEADER_CANDIDATES.length; i++) {
      var el = qs(HEADER_CANDIDATES[i]);
      if (!el) continue;
      var pos = window.getComputedStyle(el).position;
      if (pos !== 'fixed' && pos !== 'sticky') continue;
      var b = el.getBoundingClientRect().bottom;
      if (b > best) { best = b; bestSel = HEADER_CANDIDATES[i]; }
    }
    if (bestSel && !pinnedLogged) {
      pinnedLogged = true;
      console.info('[snz-facets] Fixierter Header erkannt:', bestSel, '– Offset', Math.round(best) + 'px');
    }
    return Math.min(300, Math.max(0, Math.round(best)));
  }

  function updateStickyOffset() {
    var root = qs('[data-snz-filter-section]');
    if (!root) return;
    var wrapper = root.closest('[id^="shopify-section-"]');
    if (!wrapper) return;

    var hb = getHeaderBottom(root);

    if (!isFixed) {
      var rect = wrapper.getBoundingClientRect();
      if (rect.top <= hb) {
        fixedPlaceholder = doc.createElement('div');
        fixedPlaceholder.setAttribute('data-snz-sticky-ph', '');
        fixedPlaceholder.style.height = wrapper.offsetHeight + 'px';
        fixedPlaceholder.style.marginBottom = window.getComputedStyle(wrapper).marginBottom;
        wrapper.parentNode.insertBefore(fixedPlaceholder, wrapper);
        wrapper.classList.add('snz-fixed');
        wrapper.style.top = hb + 'px';
        isFixed = true;
      }
    } else {
      var phRect = fixedPlaceholder ? fixedPlaceholder.getBoundingClientRect() : null;
      if (!phRect || phRect.top > hb) {
        wrapper.classList.remove('snz-fixed');
        wrapper.style.top = '';
        if (fixedPlaceholder && fixedPlaceholder.parentNode) fixedPlaceholder.parentNode.removeChild(fixedPlaceholder);
        fixedPlaceholder = null;
        isFixed = false;
      } else {
        wrapper.style.top = hb + 'px';
      }
    }
  }

  function markStickyDirty() {
    stickyDirty = true;
    if (stickyRaf) return;
    stickyRaf = window.requestAnimationFrame(function () {
      stickyRaf = null;
      if (!stickyDirty) return;
      stickyDirty = false;
      updateStickyOffset();
    });
  }

  doc.addEventListener('scroll', markStickyDirty, { capture: true, passive: true });
  window.addEventListener('resize', markStickyDirty, { passive: true });
  window.addEventListener('orientationchange', markStickyDirty, { passive: true });
  window.addEventListener('load', markStickyDirty);
  if (window.ResizeObserver) {
    var roTarget = qs('[data-snz-filter-section]');
    if (roTarget) new ResizeObserver(markStickyDirty).observe(roTarget);
  }

  /* ---------- Events (delegiert, überleben jeden Swap) ---------- */

  doc.addEventListener('click', function (e) {
    var el;

    el = e.target.closest('[data-snz-open]');
    if (el) { e.preventDefault(); e.stopPropagation(); Sheet.show(el); return; }

    el = e.target.closest('[data-snz-close], [data-snz-overlay]');
    if (el) { e.preventDefault(); e.stopPropagation(); Sheet.hide(); return; }

    el = e.target.closest('[data-snz-acc-head]');
    if (el) {
      e.stopPropagation();
      var acc = el.closest('[data-snz-acc]');
      if (acc) {
        var open = acc.classList.toggle('open');
        el.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      return;
    }

    el = e.target.closest('[data-snz-dd]');
    if (el) { e.stopPropagation(); togglePanel(el); return; }

    el = e.target.closest('[data-snz-brand-more]');
    if (el) { e.preventDefault(); e.stopPropagation(); ui.brandAll = true; revealAllBrands(); return; }

    el = e.target.closest('[data-mobile-add-to-cart][data-snz-unbound]');
    if (el) {
      e.preventDefault();
      e.stopPropagation();
      openMobileAtc(el.getAttribute('data-handle'));
      return;
    }

    el = e.target.closest('a[data-snz-nav]');
    if (el) {
      e.preventDefault();
      e.stopPropagation();
      if (el.getAttribute('aria-disabled') === 'true') return;
      if (el.getAttribute('data-snz-param')) applyParamNavigation(el);
      else navigate(el.getAttribute('href'));
      return;
    }

    if (!e.target.closest('[data-snz-filter-section]')) {
      if (qs('.snz-fd__panel:not([hidden])')) closeAllPanels();
    }
  }, true);

  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (Sheet.isOpen()) { Sheet.hide(); return; }
      if (qs('.snz-fd__panel:not([hidden])')) closeAllPanels();
      return;
    }
    if (e.key === 'Enter') {
      var input = e.target.closest('[data-snz-price]');
      if (input) { e.preventDefault(); applyPrice(input.closest('[data-snz-price-wrap]')); return; }
      var bs = e.target.closest('[data-snz-brand-search]');
      if (bs) e.preventDefault(); // kein Formular-Submit
    }
  });

  doc.addEventListener('change', function (e) {
    var input = e.target.closest('[data-snz-price]');
    if (!input) return;
    applyPrice(input.closest('[data-snz-price-wrap]'));
  });

  doc.addEventListener('input', function (e) {
    var input = e.target.closest('[data-snz-brand-search]');
    if (!input) return;
    ui.brandQuery[brandScopeOf(input)] = input.value;
    applyBrandSearch(input);
  });

  window.addEventListener('popstate', function () {
    navigate(window.location.href, { skipHistory: true });
  });

  markStickyDirty();
  console.info('[snz-facets] v3.0.0 bereit');
})();